var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 20,
  viewBox: "0 0 12 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.67 1.87001L9.9 0.100006L0 10L9.9 19.9L11.67 18.13L3.54 10L11.67 1.87001Z",
  fill: "#9D8DAF"
})));
export { SvgBack as ReactComponent };
export default __webpack_public_path__ + "assets/icons/back.9320c0.svg";